/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPRELATIONSHIPTYPE = {
    Brother: '1',
    Sister: '2',
    Gp: '3',
    Trustee: '4',
    Grandparent: '6',
    Grandchild: '7',
    Aunt: '8',
    Uncle: '9',
    Nephew: '10',
    Niece: '11',
    Husband: '12',
    Wife: '13',
    Father: '14',
    Mother: '15',
    Son: '16',
    Daughter: '17',
    Employer: '18',
    Employee: '19',
    Contact: '20',
    Spouse: '21',
    Child: '22',
    Friend: '23',
    Other: '24',
    Fianc: '25',
    ExSpouse: '26',
    CommonLawSpouse: '27'
} as const;
export type IAPRELATIONSHIPTYPE = typeof IAPRELATIONSHIPTYPE[keyof typeof IAPRELATIONSHIPTYPE];


export function IAPRELATIONSHIPTYPEFromJSON(json: any): IAPRELATIONSHIPTYPE {
    return IAPRELATIONSHIPTYPEFromJSONTyped(json, false);
}

export function IAPRELATIONSHIPTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPRELATIONSHIPTYPE {
    return json as IAPRELATIONSHIPTYPE;
}

export function IAPRELATIONSHIPTYPEToJSON(value?: IAPRELATIONSHIPTYPE | null): any {
    return value as any;
}

